import {HomeItemRenderer} from "./home-item-renderer"
import { SshgGallery } from "../../gallery/sshg-gallery";
import {DatareporterHelper} from "../../helpers/datareporter-helper";

export class VideoRenderer extends HomeItemRenderer{

	constructor(container:HTMLElement, private videoId: string, private videoPreviewImage: string,isForMobile:boolean){
		super(container);
		this.isForMobile = isForMobile;
	}

	public render(){
		var entryHtml = document.createElement("div");
		entryHtml.className = "p_home_book"
		entryHtml.innerHTML = `
<div class='_type'>Video</div>
<div class="dr_youtube_gallery"></div>
<div class='sshgGallery _youtubeGallery _videoOnly _hidden' data-gallery-ids='youtube:${this.videoId}'>
<div class="icon-play"></div>
<img src="${this.videoPreviewImage}" class='sshgGallery' />
</div>`;
		this.renderContainer(this.isForMobile).appendChild(entryHtml);
		new SshgGallery(entryHtml.getElementsByClassName("sshgGallery").item(0) as HTMLElement)
		DatareporterHelper.reInitDatareporterPlaceholder();
	}
}
